import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TermsService } from '@services/terms.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cstmsr-terms',
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslatePipe]
})
export class TermsComponent implements OnInit, OnDestroy {

	@Input() userContactCode?: string;
	@Input() version: string;
	termsAccepted: boolean;
	termsViewed: boolean = false;
	private termsAcceptedSubscription: Subscription;

	constructor(
		private termsService: TermsService,
	) {

	}

	ngOnInit() {
		this.termsAcceptedSubscription = this.termsService.termsAccepted.asObservable().subscribe(accepted => {
			this.termsAccepted = accepted;
		})
	}

	public async viewTerms() {
		let url = await this.termsService.getTermsUrl(this.version);
		window.open(url);
		this.termsViewed = true;
	}

	public setAcceptTerms() {
		this.termsService.acceptUserTerms(this.userContactCode, this.version);
	}
	ngOnDestroy() {
		this.termsAcceptedSubscription.unsubscribe();
	}
}